<template>
    <q-dialog v-model="showConfirmDialog" persistent>
        <q-card class="confirm-modal">
            <q-card-section>
                <p v-if="messageInBold" class="confirm-modal-text-bold">{{ messageInBold }}</p>
                <p class="q-ml-sm confirm-modal-text">{{ message }}</p>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat label="Cancelar" color="negative" @click="cancelOption" />
                <q-btn flat label="Aceptar" color="primary" @click="confirmOption" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

interface Props {
    toggleConfirmModal?: boolean;
    messageInBold?: string;
    message?: string;
    result?: boolean;
}

export default defineComponent({
    name: 'ConfirmModalComponent',
    props: {
        toggleConfirmModal: { type: Boolean },
        messageInBold: { type: String },
        message: { type: String },
        result: { type: Boolean }
    },
    emits: ['update:toggleConfirmModal', 'update:result'],
    setup(props: Props, { emit }) {

        const showConfirmDialog = computed({
            get() { return props.toggleConfirmModal },
            set(newValue) { emit('update:toggleConfirmModal', newValue) }
        });

        const cancelOption = () => {
            emit('update:toggleConfirmModal', false);
            emit('update:result', false);
        }

        const confirmOption = () => {
            emit('update:toggleConfirmModal', false);
            emit('update:result', true);
        }

        return {
            showConfirmDialog,
            cancelOption,
            confirmOption
        }
    }
});
</script>

<style lang="scss">
.confirm-modal {
    &-text{
        text-align: center;
    }

    &-text-bold {
        text-align: center;
        font-weight: bold;
    }
}
</style>
